module.exports = __webpack_public_path__ + "img/mcluster_product.e3858015.jpg";